// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3Qqjh","list":"styles_list__3vUKe"};